<!-- Added 360 images -->
@if (ppChange.propName === EActivityPropName.IMAGES_360) {
  <span class="activityChange__icon activityChange__icon--svg">
    <img class="activityChange__icon-svg" [src]="EIconPath.ACTIVITY_IMAGE_360_DARK" />
  </span>
  @if (ppChange.added.length === 0) {
    <div class="activityChange">
      {{ 'added' | ppTranslate }}
      <strong class="timeline__strong">{{ '360_photos' | ppTranslate }}.</strong>
    </div>
  }
  @if (ppChange.added.length > 0) {
    <div class="activityChange">
      {{ 'added' | ppTranslate }}
      <strong class="timeline__strong">{{ ppChange.added.length }}</strong>
      {{ ppChange.added.length === 1 ? ('360_photos' | ppTranslate) : ('360_photos' | ppTranslate) }}.
    </div>
  }
}

<!-- Added photos -->
@if (ppChange.propName === EActivityPropName.IMAGES) {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_IMAGE" />
  </span>
  @if (ppChange.added.length === 0) {
    <div class="activityChange">
      {{ 'added' | ppTranslate }}
      <strong class="timeline__strong">{{ 'images' | ppTranslate }}.</strong>
    </div>
  }
  @if (ppChange.added.length > 0) {
    <div class="activityChange">
      {{ 'added' | ppTranslate }}
      <strong class="timeline__strong">{{ ppChange.added.length }}</strong>
      {{ ppChange.added.length === 1 ? 'image' : 'images' }}.
      @if (ppChange.added.length) {
        <div class="activityChange__media-wrapper">
          @for (value of ppChange.added; track value) {
            <span class="activityChange__media-item">
              {{ value.caption }}
              <div (click)="openGallery(value.id)">
                @if (value.id) {
                  <img
                    ppImage
                    class="activityChange__uploaded-image"
                    [class.activityChange__uploaded-image--deleted]="!ppMediaAttachments[value.id]"
                    draggable="false"
                    [ppSecureSrc]="'api/v1/images/' + value.id + '/file/size/square/40'"
                    onerror="this.onerror=null;this.src=EIconPath.PLACEHOLDER_IMAGE"
                    />
                }
              </div>
            </span>
          }
        </div>
      }
    </div>
  }
}

<!-- Added video -->
@if (ppChange.propName === EActivityPropName.VIDEOS) {
  @if (ppChange.added.length === 0) {
    <div style="display: flex">
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_VIDEO" />
      </span>
      <div class="activityChange">
        {{ 'added' | ppTranslate }}
        <strong class="timeline__strong">{{ 'videos' | ppTranslate | lowercase }}.</strong>
      </div>
    </div>
  }
  @if (ppChange.added.length > 0) {
    <div style="display: flex">
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_VIDEO" />
      </span>
      <div class="activityChange">
        {{ 'added' | ppTranslate }}
        <strong class="timeline__strong">{{ ppChange.added.length }}</strong>
        {{
        ppChange.added.length === 1
        ? ('video' | ppTranslate | lowercase)
        : ('videos' | ppTranslate | lowercase)
        }}.
      </div>
    </div>
  }
}

<!-- Added file -->
@if (ppChange.propName === EActivityPropName.DOCUMENTS) {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_FILE" />
  </span>
  @if (!ppChange.added.length) {
    <div class="activityChange">
      {{ 'added' | ppTranslate }}
      <strong class="timeline__strong">{{ 'files' | ppTranslate | lowercase }}.</strong>
    </div>
  }
  @if (ppChange.added.length > 0) {
    <div class="activityChange">
      {{ 'added' | ppTranslate }}
      <strong class="timeline__strong">{{ ppChange.added.length }}</strong>
      {{
      ppChange.added.length === 1
      ? ('file' | ppTranslate | lowercase)
      : ('files' | ppTranslate | lowercase)
      }}{{ ppChange.added[0].caption ? ':' : '.' }}
      @for (file of ppChange.added.slice().reverse(); track file; let last = $last) {
        <span
          class="activity__file-name"
          >{{ file.caption }}</span
          >
        }
      </div>
    }
  }
